module.exports = __webpack_public_path__ + "static/media/googlePlay.cfbd03ad.png";